import React from 'react';
import ListItemAvatar, { ListItemAvatarProps } from '@material-ui/core/ListItemAvatar';
import { UdsFC } from '../../types';

export const MenuListItemAvatar: UdsFC<ListItemAvatarProps> = (props) => <ListItemAvatar {...props} />;
